<template>
  <div v-if="show">
    <b-card no-body class="mb-1 progress-modal" v-if="!isMinimized">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.progress-collapse variant="primary" size="sm" class="progress-collapse-btn">
          {{ $t("Pending Processes") }}
          <span class="when-opened">
            <font-awesome-icon class="icon" icon="chevron-down"/>
          </span>
          <span class="when-closed">
            <font-awesome-icon class="icon" icon="chevron-right"/>
          </span>
        </b-button>
      </b-card-header>
      <b-collapse v-model="isCollapsed" id="progress-collapse" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div>
            <div :class="{'mb-3': index < displayProgresses.length - 1}" v-for="(progress, index) in displayProgresses" :key="progress.uuid">
              <small class="mb-1">
                {{
                  progress.progressValue !== null && progress.progressValue !== undefined ?
                    $t('{name} - {progressValue}%', {name: progress.name, progressValue: progress.progressValue}) :
                    progress.name + ' - ' + $t('Process is in queue and will start soon...')
                }}
              </small>
              <b-progress animated striped variant="primary">
                <b-progress-bar :value="progress.progressValue"/>
              </b-progress>
            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <button
      v-else
      class="progress-fab"
      @click="restore"
      aria-label="Show pending processes"
      type="button"
    >
      <svg class="progress-fab__ring" viewBox="0 0 56 56">
        <g v-for="(ring, index) in ringItems" :key="`ring-${index}`">
          <circle
            class="ring-track"
            cx="28"
            cy="28"
            :r="ring.radius"
            :style="{ stroke: ring.color }"
          />
          <circle
            class="ring-progress"
            cx="28"
            cy="28"
            :r="ring.radius"
            :style="{
              stroke: ring.color,
              strokeDasharray: ring.circumference,
              strokeDashoffset: ring.dashOffset
            }"
          />
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  export default {
    name: "ProgressModal",
    data() {
      return {
        show: false,
        isCollapsed: true,
        isMinimized: false,
      }
    },
    computed: {
      ...mapState({
        progresses: state => state.progresses
      }),
      displayProgresses() {
        return this.progresses;
      },
      ringItems() {
        const palette = ['#007bff', '#28a745', '#ffc107', '#17a2b8'];
        const maxRings = Math.min(this.displayProgresses.length, 3);
        const baseRadius = 22;
        const step = 6;

        return this.displayProgresses.slice(0, maxRings).map((item, index) => {
          const radius = baseRadius - step * index;
          const value = Number.isFinite(item.progressValue) ? item.progressValue : 0;
          const circumference = 2 * Math.PI * radius;
          const dashOffset = circumference - (value / 100) * circumference;
          return {
            radius,
            color: palette[index % palette.length],
            circumference,
            dashOffset
          };
        });
      }
    },
    watch: {
      progresses(progresses) {
        const hasProgresses = progresses.length > 0;
        if (hasProgresses) {
          this.isCollapsed = true;
        } else {
          this.isMinimized = false;
        }
        this.show = hasProgresses;
      },
      isCollapsed(value) {
        if (!value && this.show) {
          this.isMinimized = true;
        }
      }
    },
    mounted() {
      const hasProgresses = this.progresses.length > 0;
      this.show = hasProgresses;
      if (hasProgresses) {
        this.isCollapsed = true;
      }
    },
    methods: {
      restore() {
        this.isMinimized = false;
        this.isCollapsed = true;
      },
    }
  }
</script>

<style lang="scss" scoped>

  .progress-modal {
    .progress-collapse-btn {
      flex: 1;

      &.collapsed > .when-opened,
      &:not(.collapsed) > .when-closed {
        display: none;
      }
    }

    position: fixed;
    width: 620px;
    background-color: #fff;
    bottom: 1em;
    right: 1em;
    z-index: 10000;
  }

  .progress-fab {
    position: fixed;
    bottom: 4.5em;
    right: 1em;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 10000;
  }

  .progress-fab__ring {
    width: 56px;
    height: 56px;
    position: absolute;
  }

  .ring-track {
    fill: none;
    stroke-width: 5;
    stroke-opacity: 0.18;
  }

  .ring-progress {
    fill: none;
    stroke-width: 5;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.3s ease;
    transform: rotate(-90deg);
    transform-origin: 28px 28px;
  }

  ///deep/ #my_id {
  //  display: none; /* Hidden by default */
  //  position: fixed; /* Stay in place */
  //  z-index: 1; /* Sit on top */
  //  width: 500px;
  //  left: calc(100% - 515px);
  //  top: auto;
  //  bottom: 0;
  //  height: auto;
  //
  //  .modal-content {
  //    max-height: 250px;
  //  }
  //}

</style>
